export const TOS_GENERAL_URL =
  'https://solutions.openlearning.com/terms-of-service/';

export const TOS_IOS_URL =
  'https://solutions.openlearning.com/terms-of-service-ios/';

export const PRIVACY_POLICY_URL =
  'https://solutions.openlearning.com/privacy-policy/';
